var Promise = require("bluebird");
var request = require("superagent");
var debug = require("debug")("goodex-api");
var proto = request.Request.prototype;
var _ = require('underscore')

request.parse["application/octet-stream"] = function(obj){
  return obj
}

proto.promise = function() {
  var self = this;
  var auth = require("../auth");
  if (auth.token) {
    self.set("Authorization", "Bearer " + auth.token);
  }
  return new Promise(function(resolve, reject) {
    self.end(function(err, resp) {
      if (err) {
        debug("FAILED: %s %s %o %o", self.method, self.url, self, self.xhr);
        return reject(resp);
      }
      debug("%s %s %o", self.method, self.url, self);
      if(resp.type == "application/json") {
        return resolve(uglyDollarValues(resp.body));
      }
      return resolve(resp.body);
    });
  });
};


proto.buffer = function(){
  this.on('request', function () {
    this.xhr.responseType = 'arraybuffer';
  })
  return this
}

module.exports = request;


// This iterates over all responses coming back
// from the api, and finds objects matching the
// $type and $values signature, and replaces it
// with value of $values.
function uglyDollarValues(obj) {
  if (_.isArray(obj)) {
    return obj.map(uglyDollarValues)
  }
  if (_.isObject(obj)) {
    if (obj.$type && obj.$values) {
      return uglyDollarValues(obj.$values);
    }
    return _.mapObject(obj, function(val, key){
      return uglyDollarValues(val);
    })
  }
  return obj;
}
